module.exports = __webpack_public_path__ + "static/media/logo_estacao.8e7dcb37.png";